<template>
    <div class="item-question-input-datepicker">
        <div class="d-flex flex-row">
            <label v-if="numberContent != ''" class="text-color-number mb-1">
                {{ numberContent }}
            </label>
            <label class="bold text-color-questions mb-1 ps-2"
                   v-html="labelContent">
            </label>
        </div>
        <div
            v-if="question.additionalInfo"
            class="form-input-help mb-1"
            v-html="question.additionalInfo"
        >
        </div>
        <date-input :error-text="translate('label.this_value_is_required')"
                    :field-id="question.questionId"
                    :help-text="question.additionalInfo"
                    :input-class="'form-select question-input-text-select'"
                    :label="labelContent"
                    :label-class="'text-color-questions'"
                    :model-answer="question.answer"
                    :name="fieldName"
                    :placeholder="question.formatDate"
                    :question="question"
                    :text-select="translateLabels.textSelect"
                    :type="'date'"
                    :validation="validationRules"
                    :has-submitted="hasSubmitted"
                    @update:modelAnswer="changeValue($event, question)"
        />
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import DateInput from "../components/date-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();
const { translate } = useTranslation();

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const fieldName = computed(() =>
    `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${props.question.fieldType}`
);

const labelContent = computed(() => {
    const label = [];

    if (Boolean(props.question.required)) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join(' ');
});

const validationRules = computed(() => {
    const rules = {
        required: false,
    };
    if (props.question.required) {
        rules.required = true;
    }

    return rules;
});

// METHODS
const changeValue = (newValue, qt) => {
    qt.answer = newValue;
    emit('field-change', fieldName.value, newValue);
    playerStore.setAnswerInFormQuestions(qt);
};

// LIFECYCLE HOOKS
onMounted(async () => {
    emit('register-field', fieldName.value, props.question.answer || '');
});
</script>
